import React, { Component } from 'react';
import { AutoComplete, Spin } from 'antd';
import axios from 'axios'
import configuration from '../config';
import { Bus } from '../helpers/utils';
import { isAuthDeniedError } from '../helpers/verifyStatusErrorResponse';

const { Option } = AutoComplete;

class CustomAutoComplete extends Component {
  state = {
    searchKey: this.props.searchKey || 'name',
    searchValue: this.props.searchValue || 'id',
    path: this.props.path,
    dataSource: [],
    filteredDataSource: [],
    loading: false
  };

  _isMonted = false;

  componentDidMount() {
    this._isMonted = true;
    if (!this.state.path && !this.props.notRequest) {
      throw Error('You must provide a path e.g: /product')
    }
    if (this.props.notRequest) {
      return;
    }
    this.getData();
  }

  componentWillUnmount() {
    this._isMonted = false
  }

  componentDidUpdate(prevProps) {
    // Atualizar o valor exibido quando o prop value muda (ex: ao clicar em edit)
    if (prevProps.value !== this.props.value && this.state.dataSource.length > 0) {
      if (this.props.value) {
        const obj = this.state.dataSource.find(v => String(v.key) === String(this.props.value));
        if (obj && obj.value) {
          this.setState({ value: obj.value });
        } else {
          this.setState({ value: '' });
        }
      } else {
        this.setState({ value: '' });
      }
    }
  }

  getData = async () => {
    const path = this.state.path;

    const url = `${configuration.URL}${path}`;
    const options = {
      headers: {
        token: global.token,
      },
    };
    this.setState({ loading: true });

    let data = await axios.get(url, options).then(r => r.data.result)
      .catch(e => {
        if (e.response && e.response.data && e.response.data.message && !isAuthDeniedError(e)) {
          Bus.emit('errorStore', { message: e.response.data.message });
        }
      });
    console.log("Data from db ->", data);
    if (this._isMonted) {
      if (!data) {
        return this.setState({ dataSource: [], filteredDataSource: [], loading: false });
      }

      const searchKey = this.state.searchKey;
      const searchValue = this.state.searchValue;

      const { labelFormatter } = this.props;
      // eslint-disable-next-line array-callback-return
      data.map((x) => {
        x.key = String(x[searchValue]);
        x.value = labelFormatter ? labelFormatter(x) : String(x[searchKey]);
      });
      console.log('props ->', this.props);
      if (this.props.value) {
        const obj = data.find(v => String(v.key) === String(this.props.value));
        console.log("Obj->", obj);
        if (obj && obj.value)
          this.setState({ value: obj.value });
      }

      if (data.length && this.props.ignoredId) {
        data = data.filter(v => v.id !== this.props.ignoredId);
      }

      this.setState({ dataSource: data, filteredDataSource: data, loading: false }, () => {
        if (this.state.dropdownOpen && data.length) {
          this.setState({ dropdownOpen: true });
        }
      });
    }
  }

  onFocus = () => {
    this.setState({
      filteredDataSource: this.state.dataSource,
      dropdownOpen: this.state.dataSource.length > 0,
    });
  };

  onBlur = () => {
    setTimeout(() => {
      if (this._isMonted) {
        this.setState({ dropdownOpen: false });
      }
    }, 200);
  };

  onSearch = searchText => {
    const filteredDataSource = searchText
      ? this.state.dataSource.filter(x => x.value.toUpperCase().includes(searchText.toUpperCase()))
      : this.state.dataSource;

    if (!searchText && this.state.value) {
      this.props.onSelect('');
    }

    this.setState({
      filteredDataSource,
      value: searchText,
      dropdownOpen: filteredDataSource.length > 0,
    });
  };

  onSelect = value => {
    this.setState({ value, dropdownOpen: false });
    if (this.props.onSelect) {
      // find the object by value or key
      let selectedObj = null;
      if (value) {
        selectedObj = this.state.filteredDataSource.find(v =>
          String(v.value).trim().toUpperCase() === String(value).trim().toUpperCase()
        ) || this.state.dataSource.find(v =>
          String(v.value).trim().toUpperCase() === String(value).trim().toUpperCase()
        );

        if (!selectedObj) {
          selectedObj = this.state.filteredDataSource.find(v =>
            String(v.key).trim() === String(value).trim()
          ) || this.state.dataSource.find(v =>
            String(v.key).trim() === String(value).trim()
          );
        }
      }
      // Passar o ID (key) como primeiro parâmetro e o objeto completo como segundo
      const idValue = selectedObj ? selectedObj.key : null;
      this.props.onSelect(idValue, selectedObj);
    }
  };

  render() {
    const { filteredDataSource, value = '', loading, dropdownOpen } = this.state;
    const children = filteredDataSource.map(x => <Option key={x.key} value={x.value}>{x.value}</Option>);
    const notFoundContent = loading
      ? <Spin size="small" />
      : (this.state.dataSource.length ? 'No matches' : 'No options available');

    return (
      <div>
        <AutoComplete
          value={String(value)}
          style={this.props.style}
          open={dropdownOpen}
          onSelect={this.onSelect}
          onSearch={this.onSearch}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          disabled={loading || this.props.disabled}
          placeholder={this.props.placeholder || ''}
          notFoundContent={notFoundContent}
        >
          {children}
        </AutoComplete>
        {loading &&
          <Spin style={{ marginTop: 3.5, marginLeft: -25 }} />
        }
      </div>
    );
  }
}

export default CustomAutoComplete;
